<template>
	<div>
		<header>
            <i></i>
            <a class="back" @click="goBack">东方号</a>
        </header>
        <div class="stepContainer">
            <div class="step">
                <div class="icon-step active"></div>
                <div class="name">账号注册</div>
            </div>
            <div class="step-line bg-red"></div>
            <div class="step">
                <div class="icon-step active"></div>
                <div class="name">类型选择</div>
            </div>
            <div class="step-line bg-red"></div>
            <div class="step">
                <div class="icon-step active"></div>
                <div class="name">资料填写</div>
            </div>
        </div>
        <div class="page" id="infoInput">
            <div class="title f-disabled">个人</div>
            <div class="form">
                <div class="form-common-head">
                    <div class="input-group" style="overflow: hidden;">
                        <label for="mediaName" class="label-control hasStar f-small">东方号名称</label>
                        <input type="text" id="mediaName" maxlength="11" v-model="registData.mediaName" class="form-control f-middle" @blur="testBlurValue(0)"/>
                        <span class="help-block" style="float: left;">2-11个字。只能包含中英文、数字、下划线</span>
                        <span v-if="errorShowStatus.mediaName" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block; margin-top: 0.4rem;">{{errorShowStatus.mediaName}}</span>
                    </div>
                    <div class="input-group">
                        <label for="mediaDesc" class="label-control hasStar f-small">东方号简介</label>
                        <input type="text" id="mediaDesc" maxlength="40" v-model="registData.mediaDesc" class="form-control f-middle" @blur="testBlurValue(1)" />
                        <span class="help-block">10-40个字。要求内容完整通顺,无特殊符号，请勿添加任何联系方式，如微博、手机号、QQ</span>
                        <span v-if="errorShowStatus.mediaDesc" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.mediaDesc}}</span>
                    </div>
                    <div class="input-group input-img-container">
                        <label for="mediaHeadPicVal" class="label-control hasStar f-small">东方号头像</label>
                        <img src="./../../assets/img/placeholderImg.png" id="avaterImg" alt=""/>
                        <input type="file" id="mediaHeadPicVal" class="form-control input-img f-middle" accept="image/jpeg,image/png" @change="mediaHeadPicUpload(2)"/>
                        <input type="hidden" name="mediaHeadPic" id="mediaHeadPic" v-model="registData.mediaHeadPic"/>
                        <span class="btn-upload f-warn f-middle" id="avaterUpload">上传</span>
                        <span class="help-block">要求清晰、健康、代表品牌形象。<br/>请勿使用二维码。<br/>最大5M,200*200像素。</span>
                        <span v-if="errorShowStatus.mediaHeadPic" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.mediaHeadPic}}</span>
                    </div>
                    <div class="cutContainer">
                        <div class="l_canvas">
                            <a id="save" href="javascript:;">保存图片</a>
                            <canvas id="canvas01"></canvas>
                        </div>
                    </div>
                    <div class="input-group">
                        <label for="field" class="label-control hasStar f-small">领域</label>
                        <select class="form-control f-middle" id="field" v-model="registDataField1" @change="filedChange(3)">
                            <option value="">请选择</option>
                            <option v-for="value in filedDataArr" :value="value.category" :key="value.category">{{value.category}}</option>
                        </select>
                        <span v-if="errorShowStatus.field" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.field}}</span>
                    </div>
                    <div class="input-group" id="field2Container" v-if="filedShow">
                        <label for="field2" class="label-control hasStar f-small">二级领域</label>
                        <select class="form-control f-middle" id="field2" v-model="registDataField2" @change="filedChange2">
                            <option v-for="value in filedDataArr2" :value="value.category" :key="value.category">{{value.category}}</option>
                            <option value="">其他</option>
                        </select>
                    </div>
                    <div class="input-group input-img-container" id="professionalContainer" v-if="professionalShow">
                        <label for="professionalFile" class="label-control hasStar f-small">专业资质</label>
                        <img src="./../../assets/img/placeholderImg.png" id="professionalPre" alt=""/>
                        <input type="file" id="professionalFile" class="form-control input-img f-middle" accept="image/jpeg,image/png" @change="professionalUpload($event, 13)"/>
                        <input type="hidden" name="professional" id="professional" v-model="registData.professional"/>
                        <span class="btn-upload f-warn f-middle" id="avaterUpload">上传</span>
                        <span class="help-block">上传资质证明可提高审核通过率。健康财经等领域必须提供相应资质证明。</span>
                        <span v-if="errorShowStatus.professional" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.professional}}</span>
                    </div>
                </div>
                <div class="form-container form-person" id="form-person">
                    <!-- <div class="input-group">
                        <label for="primarytype" class="label-control hasStar f-small">主发</label>
                        <select class="form-control f-middle" id="primarytype" v-model="registData.primarytype" @change="testChangeValue(4)">
                            <option value="">请选择</option>
                            <option value="wz">文章</option>
                            <option value="sp">视频</option>
                        </select>
                        <span v-if="errorShowStatus.primarytype" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.primarytype}}</span>
                    </div> -->
                    <!-- <div class="input-group">
                        <label for="seatof" class="label-control hasStar f-small">所在地</label>
                        <select class="form-control f-middle" id="seatof" v-model="registData.seatof" @change="testChangeValue(3)">
                            <option value="">请选择</option>
                            <option v-for="value in cityDataArr" :value="value.city" :key="value.category">{{value.city}}</option>
                        </select>
                        <span v-if="errorShowStatus.seatof" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.seatof}}</span>
                    </div> -->

                   
                    <div class="input-group input-img-container">
                        <label for="idcardPicfaceVal" class="label-control hasStar f-small">身份证正面照片</label>
                        <img src="./../../assets/img/placeholderImg.png" id="idcardPicfaceImg" alt=""/>
                        <input type="file" id="idcardPicfaceVal" class="form-control input-img f-middle" accept="image/jpeg,image/png" @change="operatorIdPicUpload($event, 4,'idcard_picface')"/>
                        <input type="hidden" name="operatorIdPic" id="idcardPicface" v-model="registData.idcardPicface"/>
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">身份证需是本人身份证照片必须清晰可见，未遮掩，图片大小不超过2M，上传身份证后请仔细核对资料</span>
                        <span v-if="errorShowStatus.idcardPicface" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.idcardPicface}}</span>
                    </div>
                    <div class="input-group input-img-container">
                        <label for="idcardReverseVal" class="label-control hasStar f-small">身份证反面照片</label>
                        <img src="./../../assets/img/placeholderImg.png" id="idcardReverseImg" alt=""/>
                        <input type="file" id="idcardReverseVal" class="form-control input-img f-middle" accept="image/jpeg,image/png" @change="operatorIdPicUpload($event, 5,'idcard_reverse')"/>
                        <input type="hidden" name="operatorIdPic" id="idcardReverse" v-model="registData.idcardReverse"/>
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">身份证需是本人身份证照片必须清晰可见，未遮掩，图片大小不超过2M，上传身份证后请仔细核对资料</span>
                        <span v-if="errorShowStatus.idcardReverse" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block">{{errorShowStatus.idcardReverse}}</span>
                    </div>
                    <div class="input-group input-img-container">
                        <label for="operatorIdPicVal" class="label-control hasStar f-small">运营者手持身份证照片</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="operatorIdPicVal" class="form-control input-img f-middle" accept="image/jpeg,image/png" @change="operatorIdPicUpload($event, 6,'operator_id_pic')"/>
                        <input type="hidden" name="operatorIdPic" id="operatorIdPic" v-model="registData.operatorIdPic"/>
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">身份证需是本人身份证照片必须清晰可见，未遮掩，图片大小不超过2M，上传身份证后请仔细核对资料</span>
                        <span v-if="errorShowStatus.operatorIdPic" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.operatorIdPic}}</span>
                    </div>
                    <div class="input-group">
                        <label for="operatorName" class="label-control hasStar f-small">运营者姓名</label>
                        <input type="text" id="operatorName" v-model="registData.operatorName" class="form-control f-middle" @blur="testBlurValue(7)" />
                        <span v-if="errorShowStatus.operatorName" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.operatorName}}</span>
                    </div>
                    <div class="input-group">
                        <label for="operator_telephone" class="label-control hasStar f-small">运营者电话</label>
                        <input type="text" id="operatorTelephone" v-model="registData.operator_telephone" class="form-control f-middle" @blur="testBlurValue(8)" />
                        <span v-if="errorShowStatus.operator_telephone" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.operator_telephone}}</span>
                    </div>
                     <div class="input-group">
                        <label for="operatorId" class="label-control hasStar f-small">运营者身份证号</label>
                        <input type="text" id="operatorId" v-model="registData.operatorId" class="form-control f-middle" @blur="testBlurValue(9)" />
                        <span v-if="errorShowStatus.operatorId" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.operatorId}}</span>
                    </div>
                    <div class="input-group">
                        <label for="operatorTelephone" class="label-control hasStar f-small">详细地址</label>
                        <input type="text" id="operatorLocation" v-model="registData.operatorLocation" class="form-control f-middle" @blur="testBlurValue(10)" />
                        <span v-if="errorShowStatus.operatorLocation" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.operatorLocation}}</span>
                    </div>
                    <div class="input-group">
                        <label for="account" class="label-control hasStar f-small">运营者邮箱</label>
                        <input type="text" id="account" v-model="registData.account" class="form-control f-middle" @blur="testBlurValue(11)" />
                        <span v-if="errorShowStatus.account" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.account}}</span>
                    </div>
                    <div class="input-group" style="position:relative">
                        <label for="v_code" class="label-control hasStar f-small">邮箱验证码</label>
                        <input type="text" id="v_code" v-model="registData.v_code" class="form-control f-middle" @blur="testBlurValue(12)" />
                        <!-- <button class="btn-email" @click="sendEmal">点击发送</button> -->
                          <button type="button" class="btn-email" @click="sendEmal" :class="btnDisabled ? 'disabled' : ''" v-if="!btnDisabled">发送验证码</button>
		                  <button type="button" class="btn-email" @click="sendEmal" :class="btnDisabled ? 'disabled' : ''" v-if="btnDisabled">重发（{{codeTimerNum}}s）</button>
                        <span v-if="errorShowStatus.v_code" style="color: rgb(248, 78, 78); font-size: 0.24rem; display: block;">{{errorShowStatus.v_code}}</span>
                    </div>
                    <div class="input-group">
                        <label for="otherContactInfo" class="label-control f-small">其他联系方式</label>
                        <input type="text" id="otherContactInfo" v-model="registData.otherContactInfo" class="form-control f-middle" />
                    </div>
                </div>
                <!-- <div class="form-container form-media" style="display:none;">
                    <div class="input-group">
                        <label for="enterpriseName" class="label-control hasStar f-small">企业名称</label>
                        <input type="text" id="enterpriseName" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">企业营业执照注册号</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group input-img-container">
                        <label for="IDCard" class="label-control hasStar f-small">企业营业执照扫描件</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="IDCard" class="form-control input-img f-middle" accept="image/jpeg,image/png"/>
                        <input type="hidden" name="IDCardVal" id="avaterVal" />
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">组织机构代码证信息清晰最大2M</span>
                    </div>
                    <div class="input-group input-img-container">
                        <label for="IDCard" class="label-control hasStar f-small">确认书扫描件</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="IDCard" class="form-control input-img f-middle" accept="image/jpeg,image/png"/>
                        <input type="hidden" name="IDCardVal" id="avaterVal" />
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">请下载<a href="http://www.eastday.com">确认书模板</a>，填写后上传</span>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">网站</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">企业地址</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="address" class="label-control hasStar f-small">所在地</label>
                        <select class="form-control f-middle" id="address">
                            <option value="">请选择</option>
                            <option v-for="value in cityDataArr" :value="value.city">{{value.city}}</option>
                        </select>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">媒体联络人姓名</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">联络人身份证号</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group input-img-container">
                        <label for="IDCard" class="label-control hasStar f-small">联络人身份证照片</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="IDCard" class="form-control input-img f-middle" accept="image/jpeg,image/png"/>
                        <input type="hidden" name="IDCardVal" id="avaterVal" />
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">照片形式请参考示例进行拍摄，身份证上的信息清晰可见,身份证上的号码必须清晰可识别，大小不超过2M</span>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">运营者电话</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">联系邮箱</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control f-small">其他联系方式</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                </div>
                <div class="form-container form-company" style="display:none;">
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">组织名称</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                        <span class="help-block">请与组织机构名称一致，并注明原媒体名称</span>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">组织机构代码</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group input-img-container">
                        <label for="IDCard" class="label-control hasStar f-small">组织机构代码证</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="IDCard" class="form-control input-img f-middle" accept="image/jpeg,image/png"/>
                        <input type="hidden" name="IDCardVal" id="avaterVal" />
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">组织机构代码证信息清晰最大2M</span>
                    </div>
                    <div class="input-group input-img-container">
                        <label for="IDCard" class="label-control hasStar f-small">确认书扫描件</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="IDCard" class="form-control input-img f-middle" accept="image/jpeg,image/png"/>
                        <input type="hidden" name="IDCardVal" id="avaterVal" />
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">请下载<a href="http://www.eastday.com">确认书模板</a>，填写后上传</span>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">网站</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">媒体地址</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="address" class="label-control hasStar f-small">所在地</label>
                        <select class="form-control f-middle" id="address">
                            <option value="">请选择</option>
                            <option v-for="value in cityDataArr" :value="value.city">{{value.city}}</option>
                        </select>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">媒体联络人姓名</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">联络人身份证号</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group input-img-container">
                        <label for="IDCard" class="label-control hasStar f-small">联络人身份证照片</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="IDCard" class="form-control input-img f-middle" accept="image/jpeg,image/png"/>
                        <input type="hidden" name="IDCardVal" id="avaterVal" />
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">照片形式请参考示例进行拍摄，身份证上的信息清晰可见,身份证上的号码必须清晰可识别，大小不超过2M</span>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">运营者电话</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">联系邮箱</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control f-small">其他联系方式</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                </div>
                <div class="form-container form-gov" style="display:none;">
                    <div class="input-group">
                        <label for="address" class="label-control hasStar f-small">所在地</label>
                        <select class="form-control f-middle" id="address">
                            <option value="">请选择</option>
                            <option v-for="value in cityDataArr" :value="value.city">{{value.city}}</option>
                        </select>
                    </div>
                    <div class="input-group">
                        <label for="address" class="label-control hasStar f-small">机构级别</label>
                        <select class="form-control f-middle" id="address">
                            <option v-for="value in cityDataArr" :value="value.city">{{value.city}}</option>
                        </select>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">机构名称</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group input-img-container">
                        <label for="IDCard" class="label-control hasStar f-small">确认书扫描件</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="IDCard" class="form-control input-img f-middle" accept="image/jpeg,image/png"/>
                        <input type="hidden" name="IDCardVal" id="avaterVal" />
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">请下载<a href="http://www.eastday.com">确认书模板</a>，填写后上传</span>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">机构地址</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">媒体联络人姓名</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">联络人身份证号</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group input-img-container">
                        <label for="IDCard" class="label-control hasStar f-small">联络人身份证照片</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="IDCard" class="form-control input-img f-middle" accept="image/jpeg,image/png"/>
                        <input type="hidden" name="IDCardVal" id="avaterVal" />
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">照片形式请参考示例进行拍摄，身份证上的信息清晰可见,身份证上的号码必须清晰可识别，大小不超过2M</span>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">运营者电话</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">联系邮箱</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control f-small">其他联系方式</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                </div>
                <div class="form-container form-other" style="display:none;">
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">组织名称</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                        <span class="help-block">请与组织机构名称一致，并注明原媒体名称</span>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">组织机构代码</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group input-img-container">
                        <label for="IDCard" class="label-control hasStar f-small">组织机构代码证</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="IDCard" class="form-control input-img f-middle" accept="image/jpeg,image/png"/>
                        <input type="hidden" name="IDCardVal" id="avaterVal" />
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">组织机构代码证信息清晰最大2M</span>
                    </div>
                    <div class="input-group input-img-container">
                        <label for="IDCard" class="label-control hasStar f-small">确认书扫描件</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="IDCard" class="form-control input-img f-middle" accept="image/jpeg,image/png"/>
                        <input type="hidden" name="IDCardVal" id="avaterVal" />
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">请下载<a href="http://www.eastday.com">确认书模板</a>，填写后上传</span>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">网站</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">组织地址</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="address" class="label-control hasStar f-small">所在地</label>
                        <select class="form-control f-middle" id="address">
                            <option value="">请选择</option>
                            <option value="境外">境外</option>
                            <option value="北京">北京</option>
                            <option value="天津">天津</option>
                            <option value="河北">河北</option>
                            <option value="山西">山西</option>
                            <option value="内蒙古">内蒙古</option>
                            <option value="辽宁">辽宁</option>
                            <option value="吉林">吉林</option>
                            <option value="黑龙江">黑龙江</option>
                            <option value="上海">上海</option>
                            <option value="江苏">江苏</option>
                            <option value="浙江">浙江</option>
                            <option value="安徽">安徽</option>
                            <option value="福建">福建</option>
                            <option value="江西">江西</option>
                            <option value="山东">山东</option>
                            <option value="河南">河南</option>
                            <option value="湖北">湖北</option>
                            <option value="湖南">湖南</option>
                            <option value="广东">广东</option>
                            <option value="广西">广西</option>
                            <option value="海南">海南</option>
                            <option value="重庆">重庆</option>
                            <option value="四川">四川</option>
                            <option value="贵州">贵州</option>
                            <option value="云南">云南</option>
                            <option value="西藏">西藏</option>
                            <option value="陕西">陕西</option>
                            <option value="甘肃">甘肃</option>
                            <option value="青海">青海</option>
                            <option value="宁夏">宁夏</option>
                            <option value="新疆">新疆</option>
                            <option value="台湾">台湾</option>
                            <option value="香港">香港</option>
                            <option value="澳门">澳门</option>
                        </select>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">媒体联络人姓名</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">联络人身份证号</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group input-img-container">
                        <label for="IDCard" class="label-control hasStar f-small">联络人身份证照片</label>
                        <img src="./../../assets/img/placeholderImg.png" id="IDCardImg" alt=""/>
                        <input type="file" id="IDCard" class="form-control input-img f-middle" accept="image/jpeg,image/png"/>
                        <input type="hidden" name="IDCardVal" id="avaterVal" />
                        <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                        <span class="help-block">照片形式请参考示例进行拍摄，身份证上的信息清晰可见,身份证上的号码必须清晰可识别，大小不超过2M</span>
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">运营者电话</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control hasStar f-small">联系邮箱</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                    <div class="input-group">
                        <label for="introduction" class="label-control f-small">其他联系方式</label>
                        <input type="text" id="introduction" class="form-control f-middle" />
                    </div>
                </div> -->
                <div class="form-common-foot">
                    <!-- <div class="supportInfoWrapper">
                        <div class="section-name">辅助材料</div>
                        <div class="supportInfoContainer" v-for="(item, index) in supportInfoNumber" :key="index">
                            <div class="supportInfo-title f-warn">辅助材料{{index+1}}<i v-if="index > 1" class="deleteInfo" @click="delSupportInfo"></i></div>
                            <div class="input-group">
                                <label :for="'platform'+(index+1)" class="label-control f-small">平台名{{(index+1)}}</label>
                                <select  :id="'platform'+(index+1)" class="form-control f-middle" v-model="supportInfoDataArr[index].platform">
                                    <option value="">请选择</option>
                                    <option v-for="value in platformDataArr" :value="value.platform" :key="value.platform">{{value.platform}}</option>
                                </select>
                            </div>
                            <div class="input-group">
                                <label :for="'media'+(index+1)" class="label-control f-small">媒体名{{(index+1)}}</label>
                                <input type="text" :id="'media'+(index+1)" placeholder="例：老鼠爱大米" class="form-control f-middle" v-model="supportInfoDataArr[index].media" />
                            </div>
                            <div class="input-group">
                                <label :for="'homePage'+(index+1)" class="label-control f-small">主页链接{{(index+1)}}</label>
                                <input type="text" :id="'homePage'+(index+1)" placeholder="已运营账号的主页链接" class="form-control f-middle" v-model="supportInfoDataArr[index].homePage" />
                            </div>
                            <div class="input-group input-img-container">
                                <label :for="'articleImgFile'+(index+1)" class="label-control f-small">文章列表截图{{(index+1)}}</label>
                                <img src="./../../assets/img/placeholderImg.png" :id="'supportImg'+(index+1)" alt=""/>
                                <input type="file" :id="'articleImgFile'+(index+1)" class="form-control input-img f-middle" accept="image/jpeg,image/png" @change="articleImgFileUpload($event)"/>
                                <input type="hidden" :name="'articleImgFileVal'+(index+1)" :id="'articleImgFileVal'+(index+1)" v-model="supportInfoDataArr[index].articleImgFile" />
                                <span class="btn-upload f-warn f-middle" id="IDCardUpload">上传</span>
                                <span class="help-block">截图中需包含：1.平台的logo;2.自媒体作者媒体名称及头像;3.文章列表（需与主页链接中的文章对应）</span>
                            </div>
                        </div>
                    </div>
                    <div class="addSupportInfo" v-if="addSupportInfoBtn" @click="addSupportInfo">
                        <i class="icon-add"></i>继续添加辅助材料，通过率会更高哦
                    </div> -->
                    <div class="agreement">
                        <label for="subInfo" class="">
                        <input type="checkbox" name="agree" id="subInfo" v-model="agreeStatus"/>
                        <span>已阅读并同意<a @click="goProtocol" class="btn-protocol">《东方号协议》</a></span>
                        </label>
                    </div>
                    <div :class="agreeStatus? 'btn-submit':'btn-submit disabled'" @click="registSubmit">提交</div>
                </div>
            </div>
        </div>
        <footer class="b-default copyright">
            <p>©上海嵩智文化传播有限公司（tt.cn）版权所有</p>
        </footer>
	</div>
</template>
<script>
    import {upload, ruzhuType, getuserinfo,register_three_1,cutImg,registCode} from './../../axios/api.js'
    import axios from 'axios'
	export default {
		name: 'RegistData',
		data (){
			return {
                registData: {
                    mediaName: '',//东方号名称
                    mediaDesc: '',
                    mediaHeadPic: '',
                    field: '',//注册领域
                    idcardPicface: '',//身份证正面
                    idcardReverse: '',//身份证反面
                    operatorIdPic: '',
                    operatorName: '',
                    operator_telephone:'',
                    operatorId: '',
                    operatorLocation:"",
                    account: '',//邮箱
                    v_code:'',//邮箱验证码
                    professional: '',
                    otherContactInfo: '',
                    auxiliaryMaterial: [],//辅助资料
                    //    mediaName: '',//东方号名称
                    // mediaDesc: '',//东方号描述
                    // mediaHeadPic: '',//东方号头像
                    // field: '',//注册领域
                    // professional: '',//注册领域的资质认证
                    // account: '',//注册账号
                    // idcardPicface: '',//身份证正面
                    // idcardReverse: '',//身份证反面
                    // operatorIdPic: '',//手持身份证
                    // operatorId: '',//身份证号
                    // operatorName: '',//运营者姓名
                    // operatorLocation: '',//运营者所在地
                    // operator_telephone: '',//运营者电话
                    // otherContactInfo: '',//其它联系方式
                    // auxiliaryMaterial: '',//辅助资料
                    // v_code: '',//验证码
                },
                registDataField2: '',
                registDataField1: '',
                supportInfoDataArr: [
                    {
                        idx: 1,
                        platform: '',
                        media: '',
                        homePage: '',
                        articleImgFile: ''
                    },{
                        idx: 2,
                        platform: '',
                        media: '',
                        homePage: '',
                        articleImgFile: ''
                    }
                ],
                agreeStatus: false,
                supportInfoNumber: ['',''],
                addSupportInfoBtn: true,
                filedDataArr: [
                    {category: '娱乐'},
                    {category: '社会'},
                    {category: '财经'},
                    {category: '军事'},
                    {category: '体育'},
                    {category: '游戏'},
                    {category: '科技'},
                    {category: '国内'},
                    {category: '国际'},
                    {category: '汽车'},
                    {category: '教育'},
                    {category: '房产'},
                    {category: '时尚'},
                    {category: '笑话'},
                    {category: '历史'},
                    {category: '健康'},
                    {category: '星座'},
                    {category: '家居'},
                    {category: '情感'},
                    {category: '旅游'},
                    {category: '动漫'},
                    {category: '育儿'},
                    {category: '宠物'}
                ],
                cityDataArr: [
                    {city: '境外'},
                    {city: '北京'},
                    {city: '天津'},
                    {city: '河北'},
                    {city: '山西'},
                    {city: '内蒙古'},
                    {city: '辽宁'},
                    {city: '吉林'},
                    {city: '黑龙江'},
                    {city: '上海'},
                    {city: '江苏'},
                    {city: '浙江'},
                    {city: '安徽'},
                    {city: '福建'},
                    {city: '江西'},
                    {city: '山东'},
                    {city: '河南'},
                    {city: '湖北'},
                    {city: '湖南'},
                    {city: '广东'},
                    {city: '广西'},
                    {city: '海南'},
                    {city: '重庆'},
                    {city: '四川'},
                    {city: '贵州'},
                    {city: '云南'},
                    {city: '西藏'},
                    {city: '陕西'},
                    {city: '甘肃'},
                    {city: '青海'},
                    {city: '宁夏'},
                    {city: '新疆'},
                    {city: '台湾'},
                    {city: '香港'},
                    {city: '澳门'}
                ],
                platformDataArr: [
                    {platform: '百家号'},
                    {platform: '大鱼号'},
                    {platform: '企鹅号'},
                    {platform: '头条号'},
                    {platform: '一点号'},
                    {platform: '微信公众号'},
                    {platform: '网易'},
                    {platform: '搜狐'},
                    {platform: '新浪'},
                    {platform: '凤凰号'},
                    {platform: '北京时间'}
                ],
                judgeRule: [
                    {
                        ele: 'mediaName', // 东方号名称
                        method: "blur",
                        func: function(val) {
                            let content = val;   
                            content = content.replace(/\s/g, '');
                            return content.length >= 2 && content.length <= 11&&(/^[a-zA-Z0-9_\u4e00-\u9fa5]+$/).test(content);
                        },
                        error: "名称格式错误"
                    },{
                        ele: 'mediaDesc', // 东方号介绍
                        method: "blur",
                        func: function(val) {
                            let content = val;
                            return (/^[\s\S]{10,40}$/).test(content);
                        },
                        error: "请输入合理的内容"
                    },{
                        ele: 'mediaHeadPic', // 东方号头像
                        method: "change",
                        func: function(val) {
                            return !!val;
                        },
                        error: "请选择头像",
                        offset: 200
                    },{
                        ele: 'field', // 领域
                        method: "change",
                        func: function(val) {
                            return val.length > 0;
                        },
                        error: "请选择领域",
                        offset: 200
                    },{
                        ele: 'idcardPicface', // 身份证正面照片
                        method: "change",
                        func: function(val) {
                            return !!val;
                        },
                        error: "请上传身份证正面照片",
                        offset: 200
                    },{
                        ele: 'idcardReverse', //身份证反面照片
                        method: "change",
                        func: function(val) {
                            return !!val;
                        },
                        error: "请上传身份证反面照片",
                        offset: 200
                    },{
                        ele: 'operatorIdPic', // 手持身份证照片
                        method: "change",
                        func: function(val) {
                            return !!val;
                        },
                        error: "请上传手持身份照片",
                        offset: 200
                    },{
                        ele: 'operatorName', // 运营者姓名
                        method: "blur",
                        func: function(val) {
                            return val.length > 0;
                        },
                        error: "请输入运营者姓名"
                    },{
                        ele: 'operator_telephone', // 运营者电话
                        method: "blur",
                        func: function(val) {
                            return (/^1[34578]\d{9}$/).test(val);
                        },
                        error: "请输入合法的运营者电话"
                    },{
                        ele: 'operatorId', // 运营者身份证号
                        method: "blur",
                        func: function(val) {
                            return (/^[1-6][0-9]{5}([1]\d{3}|(([2][0])([01]\d)))(([0][1-9])|([1][0-2]))((([0][1-9])|([12][0-9]))|([3][01]))\d{3}[\dxX]$/).test(val);
                        },
                        error: "请输入合法的运营者身份证号"
                    },{
                        ele: 'operatorLocation', // 地址
                        method: "blur",
                        func: function(val) {
                            return val.length > 0;
                        },
                        error: "请输入详细地址"
                    },{
                        ele: 'account', // 联系邮箱，运营者邮箱
                        method: "blur",
                        func: function(val) {
                            return (/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/).test(val);
                        },
                        error: "请输入合法的邮箱"
                    },{
                        ele: 'v_code', // 验证码
                        method: "blur",
                        func: function(val) {
                            return val.length > 0;
                        },
                        error: "请输入验证码"
                    },{
                        ele: 'professional', // 专业资质
                        method: "change",
                        func: function(val, status) {
                            if(!status){
                                return true;
                            }else{
                                return !!val;
                            }
                        },
                        error: "请上传资质证明文件",
                        offset: 200
                    },{
                        ele: 'otherContactInfo', // 其它联系方式
                        func: function() {
                            return true;
                        }
                    }
                ],
                entertainment: [
                    {category: '综艺'},
                    {category: '八卦'},
                    {category: '电视'},
                    {category: '电影'}
                ],
                finance: [
                    {category: '理财'},
                    {category: '基金'},
                    {category: '期货'},
                    {category: '股票'},
                    {category: '信托'},
                    {category: '新三板'},
                    {category: '黄金'},
                    {category: '不动产'},
                    {category: '保险'},
                    {category: '外汇'}
                ],
                pe: [
                    {category: '台球'},
                    {category: '羽毛球'},
                    {category: '排球'},
                    {category: '高尔夫'},
                    {category: '田径'},
                    {category: '棋牌'},
                    {category: '英超'},
                    {category: '西甲'},
                    {category: '中超'},
                    {category: '网球'},
                    {category: '意甲'},
                    {category: '德甲'},
                    {category: 'CBA'},
                    {category: 'NBA'}
                ],
                technology: [
                    {category: '数码'},
                    {category: '互联网'},
                    {category: '科学'}
                ],
                fashion: [
                    {category: '时装搭配'},
                    {category: '美容护肤'},
                    {category: '腕表'},
                    {category: '珠宝'}
                ],
                health: [
                    {category: '心理'},
                    {category: '保健'},
                    {category: '饮食'},
                    {category: '健身'},
                    {category: '减肥'}
                ],
                filedDataArr2: [],
                filedShow: false,
                professionalShow: false,
                errorShowStatus: {
                    mediaName: '',
                    mediaDesc: '',
                    mediaHeadPic: '',
                     field: '',
                    idcardPicface: '',//身份证正面
                    idcardReverse: '',//身份证反面
                    operatorIdPic: '',
                    operatorName: '',
                    operator_telephone: '',
                    operatorId: '',
                    operatorLocation:"",
                    account: '',
                    v_code:'',
                    professional: '',
                },
                mediaHeadPicIndex: '',
                btnDisabled: false,
			    codeTimerNum: 120,
			}
		},
		mounted(){
          //  this.getRouteData();
         
		},
		methods:{
            getRouteData (){
                // 获取用户信息
                // if(this.$route.query.user.mediaHeadPic){
                //  this.userInfo = this.$route.query.user;
                // }
                let that = this;
                getuserinfo().then(result => {
                    if(result.stat != 1){
                        that.$router.push({path: '/Login'})
                        return;
                    }
                    if (result.user) {
                        if(result.user.registstep == 3){
                            that.$router.push({path: '/Homepage'})
                        }
                    }
                })
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            // 用户图像上传
            mediaHeadPicUpload (index){
                this.mediaHeadPicIndex = index;
                let image = document.getElementById('avaterImg'); //预览对象
                this.clip( event , {
                    resultObj : image,
                    aspectRatio : 1,
                    autoCropArea: 1,
                    callBack: this.uploadMediaHead
                })
            },
            // 运营者手持身份证照片
            operatorIdPicUpload (e, index,fileType) {
                let that = this;
                let imgfile;
                if(e.target.files.length){
                    imgfile = e.target.files[0] || e.dataTransfer.files[0];
                }else{
                    return;
                }
                if(imgfile.size>2*1024*1024){
                    alert('请选择小于2MB的图片进行上传！');
                }else{
                    let that = this;
                     // 创建表单对象
                    let form = new FormData();
                    // 后端接受参数 ，可以接受多个参数
                    form.append("file",imgfile)
                    form.append("filetype",fileType)// 身份证正面上传
                    axios({
                        data: form,
                        url: upload,
                        method: "post"
                    }).then( result => {
                        if(result.data.code == 0){
                        
                            if(fileType == "idcard_picface"){
                                that.registData.idcardPicface = result.data.data.imgPath;
                                document.getElementById('idcardPicfaceImg').src = result.data.data.imgPath;
                               
                            }else if(fileType == "idcard_reverse"){
                                 that.registData.idcardReverse = result.data.data.imgPath;
                                document.getElementById('idcardReverseImg').src = result.data.data.imgPath;
                               
                            }else if(fileType == "operator_id_pic"){
                                that.registData.operatorIdPic = result.data.data.imgPath;
                                document.getElementById('IDCardImg').src = result.data.data.imgPath;
                               
                            }
                         //   console.log(that.registData);
                            that.testChangeValue(index);  
                             //   that.idcard_picfaceMaskShow = false;
                            // that.idcard_picface = result.data.data.imgPath
                            // that.showidcard_picface = result.data.data.imgPath
                            // that.idcard_picfaceMaskShow = false;
                        }else{
                            alert("上传失败");
                        }
                           if(fileType == "idcard_picface"){
                                 document.getElementById("idcardPicface").value = '';
                               
                            }else if(fileType == "idcard_reverse"){
                                 document.getElementById("idcardReverse").value = '';
                               
                            }else if(fileType == "operator_id_pic"){
                                document.getElementById("operatorIdPic").value = '';
                               
                            }
                      
                    })
                    // let reader  = new FileReader();
                    // if(imgfile){
                    //     reader.readAsDataURL(imgfile);
                    // }
                    // reader.addEventListener("load", function () {
                    //     let base64 = reader.result
                    //     let params = {
                    //         base64: base64,
                    //         type: 'idcard'
                    //     };
                    //     upload(params).then( result => {
                    //         if (result.stat == 0) {
                    //             that.registData.operatorIdPic = result.src;
                    //             document.getElementById('IDCardImg').src = result.src;
                    //             that.testChangeValue(index);
                    //         } else {
                    //             alert('图片上传失败！');
                    //         }
                    //         document.getElementById('operatorIdPicVal').value = '';
                    //     })
                    // }, false);
                }
            },
            // 专业资质
            professionalUpload (e, index) {
                let that = this;
                let imgfile;
                if(e.target.files.length){
                    imgfile = e.target.files[0] || e.dataTransfer.files[0];
                }else{
                    return;
                }
                if(imgfile.size>2*1024*1024){
                    alert('请选择小于2MB的图片进行上传！');
                }else{
                     // 创建表单对象
                    let form = new FormData();
                    // 后端接受参数 ，可以接受多个参数
                    form.append("file",imgfile)
                    form.append("filetype","professional")// 身份证正面上传
                    axios({
                        data: form,
                        url: upload,
                        method: "post"
                    }).then( result => {
                        if(result.data.code == 0){
                                that.registData.professional = result.data.data.imgPath;
                                document.getElementById('professionalPre').src = result.data.data.imgPath;
                                that.testChangeValue(index);
                        }else{
                            alert("上传失败");
                        }
                        document.getElementById('professionalFile').value = '';
                    })
                    // let reader  = new FileReader();
                    // if(imgfile){
                    //     reader.readAsDataURL(imgfile);
                    // }
                    // reader.addEventListener("load", function () {
                    //     let base64 = reader.result
                    //     let params = {
                    //         base64: base64,
                    //         type: 'professional'
                    //     };
                    //     upload(params).then( result => {
                    //         if (result.stat == 0) {
                    //             that.registData.professional = result.src;
                    //             document.getElementById('professionalPre').src = result.src;
                    //             that.testChangeValue(index);
                    //         } else {
                    //             alert('图片上传失败！');
                    //         }
                    //         document.getElementById('professionalFile').value = '';
                    //     })
                    // }, false);
                }
            },
            // 辅助资料
            articleImgFileUpload (e) {
                let that = this;
                let imgfile;
                let supportIndex;
                if(e.target.files.length){
                    imgfile = e.target.files[0] || e.dataTransfer.files[0];
                    supportIndex = parseFloat(e.target.getAttribute('id').slice(-1));
                }else{
                    return;
                }
                if(imgfile.size>2*1024*1024){
                    alert('请选择小于2MB的图片进行上传！');
                }else{
                    let reader  = new FileReader();
                    if(imgfile){
                        reader.readAsDataURL(imgfile);
                    }
                    reader.addEventListener("load", function () {
                        let base64 = reader.result
                        let params = {
                            base64: base64,
                            type: 'supportmaterials'
                        };
                        upload(params).then( result => {
                            if (result.stat == 0) {
                                that.supportInfoDataArr[supportIndex-1].articleImgFile = result.src;
                                document.getElementById('supportImg'+supportIndex).src = result.src;
                            } else {
                                alert('图片上传失败！');
                            }
                            e.target.value = '';
                        })
                    }, false);
                }
            },
            uploadMediaHead (url,type){
                let file = this.dataURLtoFile(url,"head");
                 let that = this;
                     // 创建表单对象
                    let form = new FormData();
                    // 后端接受参数 ，可以接受多个参数
                    form.append("file",file)
                  
                    axios({
                        data: form,
                        url: cutImg,
                        method: "post"
                    }).then( result => {
                       
                        if(result.data.code == 0){
                              that.registData.mediaHeadPic = result.data.data;
                              document.getElementById('avaterImg').src = result.data.data;
                              that.testChangeValue(that.mediaHeadPicIndex);
                        }else{
                            alert("上传失败");
                        }
                         document.getElementById('mediaHeadPicVal').value = '';
                    })
                // let params = {
                //     base64: base64,
                //     type: type
                // }
                // let that = this;
                // upload(params).then( result => {
                //     if (result.stat == 0) {
                //         that.registData.mediaHeadPic = result.src;
                //         document.getElementById('avaterImg').src = result.src;
                //         that.testChangeValue(that.mediaHeadPicIndex);
                //         // $("#mediaHeadPic").val(result.src);
                //         // $("#avaterImg").attr("src", result.src);
                //     } else {
                //         alert('图片上传失败！');
                //     }
                //     document.getElementById('mediaHeadPicVal').value = '';
                // })
            },
            filedChange (index){
                this.registData.field = this.registDataField1;
                this.registData.field2 = '';
                if(this.registDataField1=='财经'){
                    this.filedDataArr2 = this.finance;
                    this.filedShow = true;
                    this.professionalShow = true;
                }else if((this.registDataField1=='健康'&& this.registData.field2 =='')){
                    this.filedDataArr2 = this.health;
                    this.filedShow = true;
                    this.professionalShow = true;
                }else{
                    if(this.registDataField1=='娱乐'){
                        this.filedDataArr2 = this.entertainment;
                        this.filedShow = true;
                    }else if(this.registDataField1=='体育'){
                        this.filedDataArr2 = this.pe;
                        this.filedShow = true;
                    }else if(this.registDataField1=='科技'){
                        this.filedDataArr2 = this.technology;
                        this.filedShow = true;
                    }else if(this.registDataField1=='时尚'){
                        this.filedDataArr2 = this.fashion;
                        this.filedShow = true;
                    }else{
                        this.filedShow = false;
                    }
                    this.professionalShow = false;
                }
                this.testChangeValue(index);
            },
            filedChange2 (){
                if(this.registData.field2 =='保健'||this.registData.field2 =='心理'||( this.registDataField1 =='健康'&& this.registData.field2=='')||this.registDataField1=='财经'){
                    this.professionalShow = true;
                }else{
                    this.professionalShow = false;
                }
            },
            addSupportInfo (){
                let length = this.supportInfoDataArr.length;
                this.supportInfoNumber.push('');
                this.supportInfoDataArr.push({
                    idx: length+1,
                    platform: '',
                    media: '',
                    homePage: '',
                    articleImgFile: ''
                });
                if(this.supportInfoNumber.length >= 5){
                    this.addSupportInfoBtn = false;
                }
            },
            delSupportInfo (){
                let length = this.supportInfoDataArr.length;
                this.supportInfoNumber.pop('');
                this.supportInfoDataArr.pop({
                    idx: length+1,
                    platform: '',
                    media: '',
                    homePage: '',
                    articleImgFile: ''
                });
                if(this.supportInfoNumber.length < 5){
                    this.addSupportInfoBtn = true;
                }
            },
			goBack (){
				this.$router.go(-1);
			},
			goProtocol (){
				window.open(window.location.origin + '#/Protocol')
			},
            registSubmit (){
                if(!this.agreeStatus){
                    return;
                }
                if(this.registDataField2){
                    this.registData.field = this.registDataField1 + ',' + this.registDataField2;
                }
                let params = this.registData;
                // 判断全部(非辅助材料)
                if(!this.checkAll(this.registData)){
                    return;
                };
                // 判断平台、媒体名
                // if(!this.checkPlatMedia()){
                //     return;
                // }
                
                // params["supportmaterials"]=JSON.stringify(this.supportInfoDataArr);
                // params["registsource"]="wx";
                delete this.registData.field2;
                let post = {...this.registData}
                post.auxiliaryMaterial = JSON.stringify(post.auxiliaryMaterial);
                let that = this;
                  register_three_1(post).then( result => {
            		if (result.code == '0') {
                         this.$layer.dialog({
                            title: ['提示', ''], // 第一个是标题内容  第二个是标题栏的style(可以为空)
                            content: '注册成功，请耐心等待审核结果',
                            btn: ['确定'],
                            time: 800000
                            }).then( (res) =>{
                                this.$router.push({path: '/Login'})
                            })
            		  
		            } else {
		                alert(result.msg);
		            }
            	})
                // ruzhuType(params).then( result => {
                //     if (result.stat == 1) {
                //         that.$router.push({path: '/Homepage'});
                //     } else {

                //     }
                // })
            },
            checkPlatMedia (){
                let platformArr = [];
                let mediaArr = [];
                for(let j = 0; j < this.supportInfoDataArr.length; j++){
                    if(this.supportInfoDataArr[j].platform == ''){
                        this.$layer.dialog({
                            content: '平台名为空',
                            time: 2000
                        })
                        return false;
                    }
                    if(this.supportInfoDataArr[j].media == ''){
                        this.$layer.dialog({
                            content: '媒体名为空',
                            time: 2000
                        })
                        return false;
                    }
                    platformArr.push(this.supportInfoDataArr[j].platform)
                    mediaArr.push(this.supportInfoDataArr[j].media)
                }
                let platformArrSort=platformArr.sort();
                let mediaArrSort=mediaArr.sort();
                for(let k = 0 ; k < platformArrSort.length; k++){
                    if (platformArrSort[k]==platformArrSort[k+1]){
                        // alert("数组重复内容："+platformArrSort[i]);
                        this.$layer.dialog({
                            content: '平台名重复',
                            time: 2000
                        })
                        return false;
                    }
                    if (mediaArrSort[k]==mediaArrSort[k+1]){
                        // alert("数组重复内容："+mediaArrSort[i]);
                        this.$layer.dialog({
                            content: '媒体名重复',
                            time: 2000
                        })
                        return false;
                    }
                }
                return true;
            },
            checkAll (params){
                let that = this;
                for(let i = 0; i < this.judgeRule.length; i++){
                    let item = this.judgeRule[i];
                    let ele = item.ele;
                    let func = item.func;
                    let ifm = func(params[ele], this.professionalShow);
                    let error = item.error;
                    if(!ifm){
                        this.errorShowStatus[ele] = error;
                    }else{
                        this.errorShowStatus[ele] = '';
                    }
                }
                let checkObj = this.errorShowStatus;
                for( let key in checkObj){
                    if(checkObj[key]){
                        return false;
                    }
                }
                return true;
            },
            testBlurValue (index){
                if(this.registDataField2){
                    this.registData.field = this.registDataField1 + ',' + this.registDataField2;
                }
                let params = this.registData;
                let itemIndex = parseFloat(index);
                let item = this.judgeRule[itemIndex];
                let ele = item.ele;
                let func = item.func;
                let ifm = func(params[ele], this.professionalShow);
                let error = item.error;
                if(!ifm){
                    this.errorShowStatus[ele] = error;
                }else{
                    this.errorShowStatus[ele] = '';
                }
            },
            testChangeValue (index){                
                if(this.registDataField2){
                    this.registData.field = this.registDataField1 + ',' + this.registDataField2;
                }
                let params = this.registData;
                let itemIndex = parseFloat(index);
                let item = this.judgeRule[itemIndex];
                let ele = item.ele;
                let func = item.func;
                let ifm = func(params[ele], this.professionalShow);
                let error = item.error;
                if(!ifm){
                    this.errorShowStatus[ele] = error;
                }else{
                    this.errorShowStatus[ele] = '';
                }
            },
            sendEmal(){
                if(this.btnDisabled){
            		return;
            	}
                let that = this;
                if(!this.registData.account){
                    this.$layer.dialog({
									content:'请输入邮箱',
									time: 3000
                        })
                        return;
                }
               registCode({
					account: this.registData.account,
                    img_code: "",
                    step: 3,
					vtype: 'email'
				}).then( result => {
            		if (result.code == '0') {
            		    this.$layer.dialog({
									content:'验证码已发送',
									time: 3000
                        })
                        that.codeTimerNum = 120;
		                that.btnDisabled = true;
		                var timer = setInterval(function () {
		                    that.codeTimerNum--;
		                    if (that.codeTimerNum <= 0) {
		                        that.btnDisabled = false;
		                        clearInterval(timer);
		                        return;
		                    }
		                }, 1000);
		            } else {
		                alert(result.msg);
		            }
            	})
            },
		}
	}
</script>
<style scoped>
	@import "./../../common/css/reg.css";
    @import "./../../common/css/h5Base.css";
    input[type="checkbox"]{
        width: .32rem;
        height: .32rem;
    }
    input::-webkit-input-placeholder {
		color: #999;
	}
	img {
     	vertical-align: top; 
	}
    .form-common-head .help-block {
        display: inline-block;
    }
    .input-img-container .help-block {
        position: relative;
		top: 0.75rem;
        line-height: 0.45rem;
	}
	.addSupportInfo{
		font-size: 0.24rem;
	}
	.agreement{
		font-size: 0.24rem;
	}
	.cutContainer{
	    position: fixed;
	    top: 0;
	    left: 0;
	    z-index: 9999;
	    display: none;
	}
	.l_canvas #save{
	    display:block;
	    width:100%;
	    height: 1rem;
	    line-height: 1rem;
	    font-size:.3rem;
	    text-align:center;
	    color:#fff;
	    background:#9282ff;
	}
    .btn-email{
        width: 32%;
        height: .8rem;
        border-radius: 4px;
        border: 1px solid #b3b3b3;
        text-indent: .2rem;
        position: absolute;
        top:0.68rem;
        right:0;
        background: #fd979f;
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/pages/regist/registData.vue